export default __webpack_public_path__ + "static/media/course-bg.ceb26c13.jpg";